import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { Output, EventEmitter } from '@angular/core';
import { validationmethod } from 'src/app/shared/models/validationmethod';


export interface DialogData {
  ename: any;
}

@Component({
    selector: 'app-vaultobjectattributedialog',
    templateUrl: './vaultobjectattributedialog.component.html',
    styleUrls: ['./vaultobjectattributedialog.component.scss'],
    standalone: false
})

export class VaultobjectattributedialogComponent implements OnInit {

  newName_form
  validation_messages;
  backgroundColorScreen;
  buttonColor;
  components: any;
  buttonName:any = "Save";
  buttonNameClose;
  hide = false;
  allocateButtons1Boolean = false;
  closeIconButtonBoolean = false;
  closeIconButton1Boolean = false;
  bootstrapColumn: any;
  allocateButtonsBoolean = false;
  backgroundColorButton = "";
  submitted = false;
  namedata = {
    name: ""
  };
  
  constructor(public dialogRef: MatDialogRef<VaultobjectattributedialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private msg: ErrorMessages, private localStorageSettings: LocalStorageSettingsService,private validation: validationmethod) {
      this.validation_messages = this.msg.objectattributes;
      this.components = {
        buttonRenderer: Actionbutton,
      }
     }

  ngOnInit() {
    this.formnameValidation();

    this.namedata = this.data.ename;

    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");

    if (this.buttonName == "Save") {

      this.buttonNameClose = "Save";

    }

    else {

      this.buttonNameClose = "Update";

      this.hide = false;
    }

    if (this.bootstrapColumn == 1) {

      this.allocateButtons1Boolean = true;

      this.closeIconButton1Boolean = true;

    }
    else {

      this.allocateButtonsBoolean = true;

      this.closeIconButtonBoolean = true;

    }

    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");

    console.log(this.backgroundColorButton);

    console.log(this.buttonName);
  }
  formnameValidation() {
    this.newName_form = new UntypedFormGroup({
      name: new UntypedFormControl('', [Validators.required, Validators.maxLength(100), this.validation.specialCharacterValidator])
    });
  }

  reset(){
    this.namedata = {
      name: ""
    };
  }

  cancel(){
    this.dialogRef.close()
    this.reset();
  }

  addNewName(){
    this.submitted = true;
    // checking the form is valid or not while insert
      this.dialogRef.close(this.namedata);
  }
  

}
